import * as React from "react";

import { Modal } from "../Modal";
import { Button } from "../Button";
import { IButtonProps } from "../Button/Button";
import {ModalFontSizes, ModalSizes} from "../Modal/types";
import { ButtonKinds } from "../Button/types";
import styled from "styled-components";

interface ICancelProps {
  title: string;
  onClick: () => void;
}

function Cancel({ onClick, title }: ICancelProps): JSX.Element {
  return <Button size="small" theme="ghost" kind="secondary" onClick={onClick}>
    {title}
  </Button>
}

interface IModalConfirmFooterProps {
  cancelButtonText: string;
  confirmButtonText: string;
  onConfirm: () => void;
  onCancel: () => void;
  inverseOrder?: boolean;
  buttonColor?: ButtonKinds;
  buttonDisabled?: boolean;
  leftBtn?: React.ComponentType<IButtonProps>,
  rightBtn?: React.ComponentType<IButtonProps>,
}

export function ModalConfirmFooter({
  onConfirm,
  onCancel,
  confirmButtonText,
  cancelButtonText,
  inverseOrder,
  buttonColor,
  buttonDisabled,
  leftBtn,
  rightBtn
}: IModalConfirmFooterProps): JSX.Element {

  const LeftBtnComponent = leftBtn || Cancel;
  const RightBtnComponent = rightBtn || Button;

  const LeftBtn = ({ ...props }) =>
    <LeftBtnComponent
      {...props}
      title={cancelButtonText}
      onClick={onCancel}
      theme="outline"
    />

  const RightBtn = ({ ...props }) =>
    <RightBtnComponent
      {...props}
      size="small"
      kind={buttonColor}
      onClick={onConfirm}
      disabled={buttonDisabled}
    >
      {confirmButtonText}
    </RightBtnComponent>

  let left: JSX.Element;
  let right: JSX.Element;

  if (inverseOrder) {
    const copiedLeft = <LeftBtn />;

    left = <RightBtn />;
    right = copiedLeft;
  } else {
    left = <LeftBtn />;
    right = <RightBtn />;
  }

  return <Modal.Footer>
    {left}
    {right}
  </Modal.Footer>;
}

interface IModalConfirmProps extends IModalConfirmFooterProps {
  children: React.ReactNode
  title: string,
  visible: boolean,
  size?: ModalSizes,
  fontSize?: ModalFontSizes,
}

export function ModalConfirm({
  children,
  title,
  visible,
  cancelButtonText,
  confirmButtonText,
  buttonColor,
  buttonDisabled,
  size = "small",
  fontSize,
  onConfirm,
  onCancel,
  rightBtn,
  leftBtn
}: IModalConfirmProps): JSX.Element {
  return <>
    <Modal
      title={title}
      visible={visible}
      onClose={onCancel}
      size={size}
      fontSize={fontSize}
    >
      <Modal.Body>
        {children}
      </Modal.Body>

      <ModalConfirmFooter
        cancelButtonText={cancelButtonText}
        confirmButtonText={confirmButtonText}
        buttonColor={buttonColor}
        buttonDisabled={buttonDisabled}
        onConfirm={onConfirm}
        onCancel={onCancel}
        rightBtn={rightBtn}
        leftBtn={leftBtn}
      />
    </Modal>
  </>;
}